@if (this.financing && allProposals) {
  <mat-card appearance="outlined" class="mb1">
    <mat-card-content class="flex justify-between content-stretch items-stretch flex-row flex-wrap">
      <div class="mr1 flex flex-col basis-[48%]">
        <div class="filter-block">
          <label for="ltv-radio-input" class="bold" translate="">Loan to value</label>
          <div class="custom-slider mb1">
            <ngx-slider [formControl]="filterLoanToValue" [options]="filterOptionsLoanToValue">
            </ngx-slider>
          </div>
        </div>
        <div class="filter-block">
          <div class="flex justify-between content-stretch items-stretch">
            <div><label class="bold" translate="">Preferred loan</label></div>
            @if (maxLoan) {
              <div [class.underline]="maxLoan !== this.filterFormGroup.get('preferredLoan')?.value" class="pointer small-text gray" (click)="setPreferredLoan(maxLoan)">{{ 'Maximum' | translate }}: {{ maxLoan | currency:'EUR':'symbol':'1.0-0' }}</div>
            }
          </div>
          <mat-form-field appearance="outline" floatLabel="always" class="h-full w-full min-h-full min-w-full">
            <span matTextPrefix="" class="mr2">&euro;</span>
            <input matInput="" digitsOnly="" [formControl]="this.filterFormGroup.get('preferredLoan')" autocomplete="off">
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-col basis-[48%]">
        <div class="filter-block">
          <label class="bold" translate="">Sort</label><br>
          <mat-form-field appearance="outline" floatLabel="always" class="h-full w-full min-h-full min-w-full">
            <mat-select [formControl]="this.filterFormGroup.get('sort')">
              <mat-option [value]="'InterestRate'">{{ 'Interest' | translate }}</mat-option>
              <mat-option [value]="'MonthlyCharges'">{{ 'Monthly charges' | translate }}</mat-option>
              <mat-option [value]="'AverageTotalCostsPerMonth'">{{ 'Total costs' | translate }}</mat-option>
              <mat-option [value]="'Quality'">{{ 'Conditions' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="filter-block">
          <strong translate="">Fixed-rate period (year)</strong><br>
          <div class="mt1 flex justify-start content-center items-center flex-row flex-wrap gap-[1rem]">
            @for (filter of filterInterestPeriodsInMonths; track filter) {
              <div class="mb1">
                @if (!filter.active) {
                  <button (click)="setFilterInterestPeriodsInMonths(filter,true)" mat-stroked-button="">{{ filter.months / 12 }}{{ filter.reflection ? '+'+ filter.reflection / 12 : '' }}</button>
                }
                @if (filter.active) {
                  <button (click)="setFilterInterestPeriodsInMonths(filter,false)" mat-flat-button="" color="primary">{{ filter.months / 12 }}{{ filter.reflection ? '+'+ filter.reflection / 12 : '' }}</button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (isCreatingFinancing) {
  <div class="flex justify-center content-center items-center">
    <div class="flex justify-start content-center items-center">
      <div><mat-spinner diameter="18" class="gray"></mat-spinner></div>
      <div class="ml1" translate="">Creating financing</div>
    </div>
  </div>
}

@if (isCalculatingProposals && this.financing) {
  <div class="flex justify-center content-center items-center">
    <div class="flex justify-start content-center items-center">
      <div><mat-spinner diameter="18" class="gray"></mat-spinner></div>
      @if (this.financing.calculationType === 'SingleLoan') {
        <div class="ml1" translate="">Calculating proposals</div>
      }
      @if (this.financing.calculationType === 'All') {
        <div class="ml1" translate="">Calculating highest loan</div>
      }
    </div>
  </div>
}

@if (allProposals && !isCalculatingProposals) {
  <div>
    <!-- Valid items -->
    <mat-accordion multi="false">
      @for (proposalView of validProposals; track proposalView) {
        <mat-expansion-panel>
          <mat-expansion-panel-header style="height: 125px;">
            <ng-container *ngTemplateOutlet="proposalTemplate; context: { proposalView: proposalView }"></ng-container>
          </mat-expansion-panel-header>
          @for (proposal of proposalView.proposals; track proposal) {
            <div class="mt2">
              @if (proposalView.composed) {
                <strong>{{ proposal.rate?.lenderName }} {{ proposal.rate?.name }} <br></strong>
              }
              @if (proposalView.composed) {
                <span>
                  {{ 'Loan' | translate }}: {{ proposal.loan | currency:'EUR':'symbol':'1.0-0' }} /
                  {{ 'Interest' | translate }}: {{ proposal.interestRate | number:'1.2-2'}}% /
                  {{ 'Repayment' | translate }}: {{ proposal.repaymentRatePerYear | number:'1.2-2'}}%.
                </span>
              }
              <div class="mt1">
                <span [innerHTML]="'Monthly payment is ... and consists out of' | translate : {value: (proposal.financingCharges ?? 0) /12 | currency:'EUR':'symbol':'1.0-0'}"></span>&nbsp;
                @if (proposal.repaymentType === 'RepaymentFree') {
                  <span translate="">interest</span>
                }
                @if (proposal.repaymentType !== 'RepaymentFree') {
                  <span translate="">interest and repayment</span>
                  }.
                  {{ 'The contract has a duration of' | translate }} <strong>{{ (proposal.contractDurationInMonths ?? 0) / 12}} {{ 'year' | translate}}</strong>.
                  @if (proposal.repaymentType === 'Annuity') {
                    <span translate="">This is an annuity loan. The monthly charges (interest &amp; repayment) remain the same throughout the fixed-rate interest period.</span>
                  }
                  @if (proposal.repaymentType === 'RepaymentFree') {
                    <span translate="">This is an interest-only loan. You do not repay anything, and only pay interest. The monthly costs (interest) remain the same during the fixed-rate interest period.</span>
                  }
                  @if (proposal.repaymentType === 'Linear') {
                    <span translate="">This concerns a linear loan. The monthly costs (interest &amp; repayment) decrease during the fixed-rate interest period.</span>
                  }
                  @if (proposal.repaymentType === 'RepaymentFreeAndLinear') {
                    <span translate="">This loan has an interest-only &amp; linear part. The monthly costs (interest &amp; repayment) decrease during the fixed-rate interest period.</span>
                  }
                  @if (proposal.repaymentType === 'RepaymentFreeAndAnnuity') {
                    <span translate="">This loan has an interest-only &amp; annuity part. The monthly charges (interest &amp; repayment) remain the same throughout the fixed-rate interest period.</span>
                  }
                  @if ((proposal.commissionPercentage ?? 0) > 0 || (proposal.interestDepositAmount ?? 0) > 0 || (proposal.additionalIncomeRequired ?? 0) > 0 || (proposal.costsBuyer?.compensation ?? 0) < 0) {
                    <div class="mt2">
                      {{ 'Pay attention: ' | translate }}
                      @if ((proposal.commissionPercentage ?? 0) > 0 && proposal.interestDiscountPurchased) {
                        <span>
                          <span [innerHTML]="'This loan is subject to a closing fee of ...%.' | translate : {value: proposal.commissionPercentage | number:'1.0-0'}"></span>&nbsp;
                          <span [innerHTML]="'By paying ... in advance' | translate : {value: proposal.costsBuyer?.commission | currency:'EUR':'symbol':'1.0-0'}"></span>&nbsp;
                          <span [innerHTML]="'the lender offers a interest discount of ...% during the fixed-interest period.' | translate : {value: proposal.interestDiscountPurchased | number:'1.2-2'}"></span>&nbsp;
                          <span [innerHTML]="'This means you only pay ...% interest monthly and you can often borrow more.' | translate : {value: (proposal.interestRate ?? 0) - (proposal.interestDiscountPurchased ?? 0) | number:'1.2-2'}"></span>&nbsp;
                          {{ 'Closing commission is not refunded in case of interim repayment.' | translate }}
                          <span [innerHTML]="'The closing commission means that ... less is available for a purchase or refinancing.' | translate : {value: proposal.costsBuyer?.commission | currency:'EUR':'symbol':'1.0-0'}"></span>
                        </span>
                      }
                      @if ((proposal.commissionPercentage ?? 0) > 0 && !proposal.interestDiscountPurchased) {
                        <span>
                          <span [innerHTML]="'This loan is subject to a closing fee of ...%.' | translate : {value: proposal.commissionPercentage | number:'1.2-2'}"></span>
                        </span>
                      }
                      @if ((proposal.interestDepositAmount ?? 0) > 0) {
                        <span>
                          {{ 'With this loan there is an interest deposit.' | translate }}
                          <span [innerHTML]="'By reserving ...' | translate : {value: proposal.interestDepositAmount | currency:'EUR':'symbol':'1.0-0'}"></span>&nbsp;
                          <span [innerHTML]="'the lender offers a interest discount of ...% during the fixed-interest period.' | translate : {value: proposal.interestDiscountPurchased | number:'1.2-2'}"></span>&nbsp;
                          <span [innerHTML]="'This means you only pay ...% interest monthly and you can often borrow more.' | translate : {value: (proposal.interestRate ?? 0) - (proposal.interestDiscountPurchased ?? 0) | number:'1.2-2'}"></span>&nbsp;
                          {{ 'In the event of an interim repayment, the remaining amount in the interest deposit will be repaid.' | translate }}
                          <span [innerHTML]="'The interest deposit means that ... less is available for a purchase or refinancing.' | translate : {value: proposal.interestDepositAmount | currency:'EUR':'symbol':'1.0-0'}"></span>
                        </span>
                      }
                      @if ((proposal.costsBuyer?.compensation ?? 0) < 0) {
                        <span>
                          <span [innerHTML]="'The lender offers a compensation of ... for all costs that the investor has to incur.' | translate : {value: (proposal.costsBuyer?.compensation ?? 0) * -1 | currency:'EUR':'symbol':'1.0-0'}"></span>&nbsp;
                        </span>
                      }
                      @if ((proposal.additionalIncomeRequired ?? 0) > 0) {
                        <span>
                          {{ 'This loan requires an additional income of' | translate }} <strong>{{ proposal.additionalIncomeRequired | currency:'EUR':'symbol':'1.0-0' }}</strong>.
                        </span>
                      }
                    </div>
                  }
                  @if (proposal.repaymentType !== 'RepaymentFree' && proposal.repaymentFreePercentage) {
                    <div class="mt2">
                      <span [translateParams]="{ value: proposal.repaymentFreePercentage.toFixed(0) }" translate="">The moment the loan is less than ... of the value, the repayment obligation lapses and only interest is due.</span>
                    </div>
                  }
                </div>
                @if (proposal.conditions) {
                  <div class="flex flex-row flex-wrap gap-[1rem]">
                    <div class="basis-full xl:flex-1">
                      @if (proposal.conditions.maximumAcceptancePeriodInDays != null) {
                        <div class="mt2 flex flex-col">
                          <label class="bold" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="De periode die belegger krijgt om akkoord te gaan met de offerte.">
                            <span translate="">Acceptance period</span>
                          </label>
                          <span>{{proposal.conditions.maximumAcceptancePeriodInDays }} <span translate="">days</span></span>
                        </div>
                      }
                      @if (proposal.conditions.interestGuarantee != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Interest guarantee</span>
                          @if (proposal.conditions.interestGuarantee) {
                            @if (proposal.conditions.numberOfDaysInterestGuarantee) {
                              <span>{{proposal.conditions.numberOfDaysInterestGuarantee}}
                                <span translate="">days from</span> {{proposal.conditions.startMomentInterestGuarantee}}</span>
                              }
                            }
                            @if (!proposal.conditions.interestGuarantee) {
                              <span translate="">No</span>
                            }
                          </div>
                        }
                        @if (proposal.conditions.interestGuaranteeExtendable != null) {
                          <div class="mt2 flex flex-col">
                            <span class="bold" translate="">Interest guarantee extendable</span>
                            @if (proposal.conditions.interestGuaranteeExtendable) {
                              @if (proposal.conditions.interestGuaranteeExtendableInDays) {
                                <span><span translate="">with</span> {{proposal.conditions.interestGuaranteeExtendableInDays}} <span translate="">days</span>
                                @if (proposal.conditions.interestGuaranteeExtendingCostsPercentage) {
                                  &nbsp;<span translate="">against</span> {{proposal.conditions.interestGuaranteeExtendingCostsPercentage | number:'1.2-2'}}% <span translate="">per month</span>
                                }
                              </span>
                            }
                          }
                          @if (!proposal.conditions.interestGuaranteeExtendable) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                      @if (proposal.conditions.combiningFixedInterestPeriods != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Combining fixed interest periods</span>
                          @if (proposal.conditions.combiningFixedInterestPeriods) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.combiningFixedInterestPeriods) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                      @if (proposal.conditions.suretyRequired != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Surety required</span>
                          @if (proposal.conditions.suretyRequired) {
                            <span translate="">Yes@if (proposal.conditions.suretyRequiredAboveLoanToValue) {
                              <span>, {{'only above' | translate}} {{proposal.conditions.suretyRequiredAboveLoanToValue | number:'1.0-0'}}%</span>
                            }</span>
                          }
                          @if (!proposal.conditions.suretyRequired) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                      @if (proposal.conditions.cancellationFees != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Cancellation fees</span>
                          @if (proposal.conditions.cancellationFees) {
                            <span>{{proposal.conditions.cancellationFees | number:'1.0-0'}}%</span>
                          }
                          @if (!proposal.conditions.cancellationFees) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="basis-full xl:flex-1">
                      @if (proposal.conditions.interimIncrease != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Interim increase</span>
                          @if (proposal.conditions.interimIncrease) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.interimIncrease) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                      @if (proposal.conditions.passThroughArrangement != null) {
                        <div class="mt2 flex flex-col">
                          <label class="bold" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Met een doorgeefregeling kan de koper van de belegging het resterende deel van de hypotheek overnemen. Dit maakt de belegging aantrekkelijker voor potentiële kopers en vergroot de verkoopkansen.">
                            <span translate="">Pass through arrangement</span>
                          </label>
                          @if (proposal.conditions.passThroughArrangement) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.passThroughArrangement) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                      @if (proposal.conditions.relocationArrangement != null) {
                        <div class="mt2 flex flex-col">
                          <label class="bold" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Met een verhuisregeling kan de belegger zijn hypotheek meenemen naar een nieuwe belegging.">
                            <span translate="">Relocation arrangement</span>
                          </label>
                          @if (proposal.conditions.relocationArrangement) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.relocationArrangement) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                      @if (proposal.conditions.antiSpeculationClause != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Anti speculation clause</span>
                          @if (proposal.conditions.antiSpeculationClause) {
                            @if (proposal.conditions.numberOfYearsAntiSpeculationClause === null) {
                              <span translate="">Yes</span>
                            }
                            @if (proposal.conditions.numberOfYearsAntiSpeculationClause !== null) {
                              <span><span translate="">First</span> {{proposal.conditions.numberOfYearsAntiSpeculationClause }} <span translate="">year</span></span>
                            }
                          }
                          @if (!proposal.conditions.antiSpeculationClause) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                      @if (proposal.conditions.antiSpeculationClause) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Anti speculation clause exit fee</span>
                          <span>
                            @if ((proposal.conditions.antiSpeculationClauseExitFeePercentageFirstYear ?? 0) > 0) {
                              <span>{{proposal.conditions.antiSpeculationClauseExitFeePercentageFirstYear | number:'1.0-0'}}% <span translate="">in the first year</span></span>
                            }
                            @if ((proposal.conditions.antiSpeculationClauseExitFeePercentageSecondYear ?? 0) > 0) {
                              <span>, {{proposal.conditions.antiSpeculationClauseExitFeePercentageSecondYear | number:'1.0-0'}}% <span translate="">in the second year</span></span>
                            }
                            @if ((proposal.conditions.antiSpeculationClauseExitFeePercentageThirdYear ?? 0) > 0) {
                              <span>, {{proposal.conditions.antiSpeculationClauseExitFeePercentageThirdYear | number:'1.0-0'}}% <span translate="">in the third year</span></span>
                            }
                          </span>
                        </div>
                      }
                    </div>
                    <div class="basis-full xl:flex-1">
                      @if (proposal.conditions.maximumPortfolioSize != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Maximum portfolio size</span>
                          <span>{{proposal.conditions.maximumPortfolioSize | currency:'EUR':'symbol':'1.0-0'}}</span>
                        </div>
                      }
                      @if (proposal.conditions.interestDiscountBasedOnPortfolioSize != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Interest discount based on portfolio size</span>
                          @if (proposal.conditions.interestDiscountBasedOnPortfolioSize) {
                            @if (proposal.conditions.interestDiscountFromPortfolioSize === null) {
                              <span translate="">Yes</span>
                            }
                            @if (proposal.conditions.interestDiscountFromPortfolioSize !== null) {
                              <span><span translate="">Above</span> {{proposal.conditions.interestDiscountFromPortfolioSize | currency:'EUR':'symbol':'1.0-0'}}</span>
                            }
                          }
                          @if (!proposal.conditions.interestDiscountBasedOnPortfolioSize) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                      @if (proposal.conditions.repaymentWithoutPenalty != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Repayment without penalty</span>
                          @if (proposal.conditions.repaymentWithoutPenalty) {
                            @if (proposal.conditions.repaymentPercentagePerYearWithoutPenalty === null) {
                              <span translate="">Yes</span>
                            }
                            @if (proposal.conditions.repaymentPercentagePerYearWithoutPenalty !== null) {
                              <span><span translate="">Maximum</span> {{proposal.conditions.repaymentPercentagePerYearWithoutPenalty | number:'1.0-0'}}% <span translate="">per year</span> {{proposal.conditions.repaymentWithoutPenaltyRestrictions}}</span>
                            }
                          }
                          @if (!proposal.conditions.repaymentWithoutPenalty) {
                            <span translate="">No</span>
                          }
                        </div>
                      }
                      @if (proposal.conditions.automaticInterestRateReductionUponRepayment != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Automatic interest rate reduction upon repayment</span>
                          @if (proposal.conditions.automaticInterestRateReductionUponRepayment) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.automaticInterestRateReductionUponRepayment) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                      @if (proposal.conditions.freeChoiceFixedInterestPeriodWhenExtending != null) {
                        <div class="mt2 flex flex-col">
                          <span class="bold" translate="">Free choice fixed interest period when extending</span>
                          @if (proposal.conditions.freeChoiceFixedInterestPeriodWhenExtending) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!proposal.conditions.freeChoiceFixedInterestPeriodWhenExtending) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (proposalView.composed) {
              <div class="mt2 flex flex-col">
                <table>
                  <tr>
                    <th></th>
                    @for (proposal of proposalView.proposals; track proposal) {
                      <th style="text-align: left;">{{ proposal.rate?.lenderName }} <br> {{ proposal.rate?.name }}</th>
                    }
                  </tr>
                  @for (address of getProposalAddresses(proposalView); track address) {
                    <tr>
                      <td>{{ address.addressLine1 }}, {{ address.city }}</td>
                      @for (proposal of proposalView.proposals; track proposal) {
                        <td>
                          @if (isAddressFinancedOnProposal(address, proposal)) {
                            <mat-icon class="green">check</mat-icon>
                          }
                          @if (!isAddressFinancedOnProposal(address, proposal)) {
                            <mat-icon class="red">clear</mat-icon>
                          }
                        </td>
                      }
                    </tr>
                  }
                </table>
              </div>
            }
            @if (proposalView.maximumLoan && proposalView.maximumLoan !== this.filterFormGroup.get('preferredLoan')?.value) {
              <div class="mt2">
                <ng-container *ngTemplateOutlet="maxLoanLink; context: { proposal: proposalView }"></ng-container>
              </div>
            }
            <mat-action-row class="flex justify-end content-center items-center">
              @if (proposalView.costs > 0) {
                <div class="bold">
                  <span translate="">The costs of applying for this financing are</span> {{ proposalView.costs | currency:'EUR':'symbol':'1.0-0' }}
                </div>
              }
              <unite-loading-button (click)="selectProposals(proposalView)" style="width: 200px; height: 50px;" [text]="'Select' | translate" icon="checked" color="primary" [loading]="isSelectingProposals">
              </unite-loading-button>
            </mat-action-row>
          </mat-expansion-panel>
        }
      </mat-accordion>
      <div class="mt2"></div>
      <!-- Invalid items-->
      <mat-accordion multi="false">
        @for (invalidProposal of invalidProposals; track invalidProposal) {
          <mat-expansion-panel [disabled]="!invalidProposal.proposalView">
            <!-- Render a invalid proposal -->
            @if (invalidProposal.proposalView) {
              <mat-expansion-panel-header style="height: 125px;" class="black-white-opacity">
                <ng-container *ngTemplateOutlet="proposalTemplate; context: { proposalView: invalidProposal.proposalView }"></ng-container>
              </mat-expansion-panel-header>
            }
            @if (invalidProposal.proposalView) {
              <div>
                <ul>
                  @for (description of invalidProposal.descriptions; track description) {
                    <li>{{ description }}</li>
                  }
                  @if (invalidProposal.proposalView?.maximumLoan) {
                    <li><ng-container *ngTemplateOutlet="maxLoanLink; context: { proposal: invalidProposal.proposalView }"></ng-container></li>
                  }
                </ul>
              </div>
            }
            <!-- Render a rejection -->
            @if (!invalidProposal.proposalView) {
              <mat-expansion-panel-header style="height: 125px;">
                <div class="flex justify-between content-center items-center gap-[1rem] basis-full">
                  <div class="black-white-opacity flex justify-center content-center items-center flex-col basis-1/5">
                    @if (invalidProposal.lenders.length > 1) {
                      <div class="img-title flex flex-col justify-center content-center items-center w-full">
                        <mat-icon>filter_{{invalidProposal.lenders.length}}</mat-icon>
                      </div>
                    }
                    @if (invalidProposal.lenders.length === 1) {
                      <div class="img-title flex flex-col justify-center content-center items-center w-full">
                        <img src="/assets/logos/{{invalidProposal.lenders[0].lenderName | lowercase}}.png" alt="{{invalidProposal.lenders[0].lenderName}}">
                      </div>
                    }
                    @for (lender of invalidProposal.lenders; track lender) {
                      <div class="center small-text gray">
                        @if (invalidProposal.lenders.length > 1) {
                          {{ lender.lenderName}}
                        }
                        {{lender.rate}}
                      </div>
                    }
                  </div>
                  <div class="basis-4/5">
                    @for (description of invalidProposal.descriptions; track description) {
                      <span class="gray">{{ description }} <br></span>
                    }
                  </div>
                </div>
              </mat-expansion-panel-header>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
      <ng-template #maxLoanLink="" let-proposal="proposal">
        @if (proposal.maximumLoan) {
          <span>{{ 'The maximum possible loan for this product related to this real estate is' | translate }} <a class="link" (click)="setPreferredLoan(proposal.maximumLoan)">{{ proposal.maximumLoan | currency:'EUR':'symbol':'1.0-0' }}</a></span>
        }
      </ng-template>
      <ng-template #proposalTemplate="" let-proposalView="proposalView">
        <div class="flex justify-between content-center items-center gap-[1rem] basis-full">
          <div class="flex justify-center content-center items-center flex-col basis-[19%]">
            @if (proposalView.lenders.length > 1) {
              <div class="img-title flex flex-col justify-center content-center items-center w-full">
                <mat-icon>filter_{{proposalView.lenders.length}}</mat-icon>
              </div>
            }
            @if (proposalView.lenders.length === 1) {
              <div class="img-title flex flex-col justify-center content-center items-center w-full">
                <img src="/assets/logos/{{proposalView.lenders[0].lenderName | lowercase}}.png" alt="{{proposalView.lenders[0].lenderName}}">
              </div>
            }
            @for (lender of proposalView.lenders; track lender) {
              <div class="center small-text gray">
                @if (proposalView.lenders.length > 1) {
                  {{ lender.lenderName}}
                }
                {{lender.rate}}
              </div>
            }
          </div>
          <div class="flex justify-center content-center items-center flex-col basis-[19%]">
            <div>
              <span class="header">{{ proposalView.interestRate | number:'1.2-2'}}%</span>
            </div>
            <div class="center small-text gray" translate="">Interest</div>
          </div>
          <div class="flex justify-center content-center items-center flex-col basis-[19%]">
            <div class="nowrap">
              @if (proposalView.interestPeriodInMonths % 12 === 0) {
                <span class="header">{{ proposalView.interestPeriodInMonths / 12 }}
                  @if (proposalView.interestReflectionPeriodInMonths > 0) {
                    <span>+ {{ proposalView.interestReflectionPeriodInMonths / 12 }} </span>
                  }
                  <span translate="">year</span>
                </span>
              }
              @if (proposalView.interestPeriodInMonths % 12 > 0) {
                <span class="header">{{ proposalView.interestPeriodInMonths }}
                  @if (proposalView.interestReflectionPeriodInMonths > 0) {
                    <span>+ {{ proposalView.interestReflectionPeriodInMonths }} </span>
                  }
                  <span translate="">months</span>
                </span>
              }
            </div>
            @if (proposalView.interestReflectionPeriodInMonths > 0) {
              <div class="center small-text gray nowrap" translate="">
                <span translate="" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Dit voorstel heeft rentevaste periode inclusief rentebedenktijd. Gedurende de rentebedenktijd heeft de belegger tijd om de rente opnieuw vast te zetten. De rente blijft gedurende de volledige periode gelijk.">
                  Fixed-rate
                </span>
              </div>
            }
            @if (!proposalView.interestReflectionPeriodInMonths || proposalView.interestReflectionPeriodInMonths === 0) {
              <div class="center small-text gray" translate="">Fixed-rate</div>
            }
          </div>
          <div class="flex justify-center content-center items-center flex-col basis-[19%]">
            <star-rating style="margin-bottom: 0.35rem;" staticColor="ok" size="medium" [readOnly]="true" [starType]="'svg'" [showHalfStars]="true" [rating]="proposalView.score" [disabled]="!proposalView.score"></star-rating>
            <div class="center small-text gray" translate="">Conditions</div>
          </div>
          <div class="flex justify-center content-center items-center flex-col basis-[19%]">
            @if (filterFormGroup.get('sort')?.value !== 'AverageTotalCostsPerMonth') {
              <div class="flex justify-center content-start items-start flex-col">
                <span class="header">{{proposalView.monthlyCharges | currency:'EUR':'symbol':'1.0-0' }}</span>
              </div>
              <div class="center small-text gray nowrap" translate=""></div>
              <div class="center small-text gray nowrap" translate="">
                <span translate="" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Dit zijn de maandelijke lasten die per maand moeten worden betaald.">
                  per month
                </span>
              </div>
            }
            @if (filterFormGroup.get('sort')?.value === 'AverageTotalCostsPerMonth') {
              <div class="flex justify-center content-start items-start flex-col">
                <span class="header">{{proposalView.averageTotalCostsPerMonth | currency:'EUR':'symbol':'1.0-0' }}</span>
              </div>
              <div class="center small-text gray nowrap" translate="">
                <span translate="" matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" matTooltip="Dit betreffen alle (eenmalige en doorlopende) kosten, exclusief overdrachtsbelasting, die de belegger maakt bij deze financiering, gemiddeld per maand.">
                  average p/m
                </span>
              </div>
            }
          </div>
          <div class="flex justify-center content-start items-start flex-col basis-[5%]">
            @if (proposalView.commission) {
              <mat-icon class="icon-large red">notification_important</mat-icon>
            }
            @if (proposalView.interestDeposit) {
              <mat-icon class="icon-large orange">notification_important</mat-icon>
            }
            @if (proposalView.compensation) {
              <mat-icon class="icon-large green">euro_symbol</mat-icon>
            }
          </div>
        </div>
      </ng-template>
      @if (validProposals.length === 0 && invalidProposals.length === 0) {
        <div class="center">
          {{ 'No proposals found' | translate }}
        </div>
      }
    </div>
  }